import { themeVars } from '@coverflex-tech/hypernova';
import { style } from '@vanilla-extract/css';

const container = style({
  display: 'flex',
  flexDirection: 'row',
  columnGap: '8rem',
});

const column = style({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
});

const title = style({
  marginBottom: themeVars.spacing.lg,
  color: themeVars.color.semantic.text.neutral30,
});

export const css = {
  container,
  column,
  title,
};
